module.exports = __webpack_public_path__ + "res/ic_globe.51236c05cc0943ce751f303e48fabb84.png";